<template>
  <div
    id="nav"
    class="c-navigation"
  >
    <div class="c-navigation__bg" />

    <div
      class="c-navigation__menu c-navigation__menu--left"
      @click="closeMenu()"
    >
      <a
        class="c-navigation__menu-item"
        href="https://foljeton.dk"
      >Dagens forside</a>
      <router-link
        to="/"
        class="c-navigation__menu-item"
        @event.native="handleNavigationState($event)"
      >
        Din indbakke
      </router-link>
      <!-- <router-link
        v-if="user"
        to="/koeb">Køb</router-link>
        class="c-navigation__menu-item"-->
      <router-link
        v-if="!user"
        to="/opret-bruger"
        class="c-navigation__menu-item"
      >
        Opret bruger
      </router-link>
      <router-link
        v-if="!user"
        to="/produkter"
        class="c-navigation__menu-item"
      >
        Produkter
      </router-link>
      <router-link
        v-if="user && user.fljState === 'active'"
        to="/produkt-indstillinger"
        class="c-navigation__menu-item"
      >
        Produkter
      </router-link>
      <router-link
        v-if="user"
        to="/bruger"
        class="c-navigation__menu-item"
      >
        Bruger
      </router-link>
      <router-link
        v-if="user"
        to="/abonnement"
        class="c-navigation__menu-item"
      >
        Abonnement
      </router-link>
      <!-- <router-link
        v-if="user"
        to="/betaling"
        class="c-navigation__menu-item"
      >
        Betaling</
      router-link> -->
      <!-- <router-link
        to="/om-os"
        class="c-navigation__menu-item"
      >
        Om Føljeton
      </router-link> -->
    </div>

    <div
      class="c-navigation__menu c-navigation__menu--right"
      @click="closeMenu()"
    >
      <router-link
        v-if="!user"
        to="/login"
        class="c-navigation__menu-item"
      >
        Login
      </router-link>
      <router-link
        v-if="user"
        to="/logout"
        class="c-navigation__menu-item"
      >
        Log ud
      </router-link>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../components/EventBus";

export default {
  name: "Navigation",
  data() {
    return {
      user: this.$userService.user
    };
  },
  mounted() {

    console.log(this.$userService);

    // TODO: Delete this
    // this.$userService.user.fljState = "active";

    EventBus.$on("user-state-change", user => {

      console.log("on user state");
      this.user = user;
      console.log(user);

    } );

  },
  methods: {
    update(e) {
      console.log(e);
    },
    closeMenu() {
      if (this.$parent.closeMenu) {
        this.$parent.closeMenu();
      }
    }

    /*showBuyLink(user) {
      if (!user) {
        return false;
      }
      if (user.fljState === "inactive") {
        // TODO make whitelist
        return true;
      }
      return false;
    }*/
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../vars.scss";
@import "../mixins.scss";

.c-navigation {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  // height: 100%;
  // padding: 1.777em;
  color: $white;
  font-family: $ffBody;

  @include bp($tablet) {
    padding-right: 1.777em;
    padding-left: 1.777em;
  }

  &__bg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    background-color: $blue;
    background-color: $white;
  }

  &__menu {
    height: 100%;
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    padding-top: 1.777em;
    padding-bottom: 1.777em;

    &--left {
      @include bp('max-width' #{$tablet - 1}) {
        flex-direction: column;
        align-items: flex-start;
        padding-right: $pageGutter;
        padding-left: $pageGutter;
        padding-top: 100px;
        font-size: 1.5em;
      }
    }

    &--right {
      justify-content: flex-end;
      margin-right: 0;
      margin-left: auto;

      @include bp('max-width' #{$tablet - 1}) {
        padding-right: 1em;
        // padding-top: 1em;
      }
    }
  }

  &__bg,
  &__menu--left {
    will-change: transform;
    transition: transform 400ms ease-in-out;
    transform: translateY(-100%);

    .open & {
      transform: translateY(0);
    }

    @include bp('max-width' #{$tablet - 1}) {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      height: 100vh;
    }
  }

  &__menu-item {
    margin-top: 0.1em;
    text-decoration: none;

    & + &:not(&--right) {
      @include bp($tablet) {
        margin-left: 2.333em;
      }
    }

    &--right {
      align-self: flex-end;
      margin-right: 0;
      margin-left: auto;
    }
  }
}

</style>
